/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown>, currentGroup: NonNullable<unknown> }} Email_Already_In_Use_In_Another_GroupInputs */



/**
* | output |
* | --- |
* | "This user is already in the group “{group}”, they will be moved to the group “{currentGroup}”" |
*
* @param {Email_Already_In_Use_In_Another_GroupInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const email_already_in_use_in_another_group = /** @type {((inputs: Email_Already_In_Use_In_Another_GroupInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Already_In_Use_In_Another_GroupInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`This user is already in the group “${i?.group}”, they will be moved to the group “${i?.currentGroup}”`)
	return /** @type {LocalizedString} */ (`Cet utilisateur se trouve déjà dans le groupe “${i?.group}”, il sera
déplacé vers le groupe “${i?.currentGroup}”`)
});